var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F61",
    fillRule: "nonzero",
    d: "M10.775.35a1.65 1.65 0 0 1 1.644 1.508l.006.142-.001 1.35h4.926a.65.65 0 0 1 .096 1.293l-.096.007h-1.013l-1.404 9.729a2.65 2.65 0 0 1-2.453 2.266l-.17.005H6.24a2.65 2.65 0 0 1-2.593-2.103l-.03-.168L2.212 4.65H1.2a.65.65 0 0 1-.643-.554L.55 4a.65.65 0 0 1 .554-.643L1.2 3.35h4.924L6.125 2A1.65 1.65 0 0 1 7.633.356L7.775.35h3zm4.249 4.3H3.525l1.38 9.543c.089.62.59 1.09 1.202 1.15l.133.007h6.07a1.35 1.35 0 0 0 1.31-1.027l.026-.13 1.378-9.543zm-8.68 1.907l.023.094 1 6a.6.6 0 0 1-1.16.292l-.024-.094-1-6a.6.6 0 0 1 1.16-.292zm6.53-.399a.6.6 0 0 1 .493.69l-1 6a.6.6 0 1 1-1.184-.197l1-6a.6.6 0 0 1 .69-.493zM9.275 6.15a.6.6 0 0 1 .6.6v6a.6.6 0 1 1-1.2 0v-6a.6.6 0 0 1 .6-.6zm1.5-4.5h-3a.35.35 0 0 0-.343.28L7.425 2l-.001 1.35h3.7L11.125 2a.35.35 0 0 0-.28-.343l-.07-.007z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d441c0480ffbce06025f3372a1b145d8.svg";
export { ForwardRef as ReactComponent };